const companies = [
  { name: "NovaTech Solutions", sector: "Tecnologia" },
  { name: "Grupo Vertice", sector: "Consultoria" },
  { name: "Conexa Digital", sector: "Marketing" },
  { name: "Prime Automóveis", sector: "Varejo" },
  { name: "Velox Logística", sector: "Logística" },
  { name: "Integra Saúde", sector: "Saúde" },
  { name: "Fintech Plus", sector: "Financeiro" },
  { name: "Educar Online", sector: "Educação" },
];

const TrustedBySection = () => {
  return (
    <section id="clientes" className="py-12 md:py-16 relative overflow-hidden border-t border-b border-border/30" aria-label="Empresas que confiam na Zavvi">
      {/* Background */}
      <div className="absolute inset-0 bg-surface-card/30" aria-hidden="true" />

      <div className="container mx-auto px-4 relative z-10">
        {/* Header */}
        <p className="text-center text-muted-foreground text-xs md:text-sm mb-8 md:mb-10">
          Empresas que confiam na <span className="text-gradient-zavvi font-semibold">Zavvi.ai</span>
        </p>

        {/* Desktop: Scrolling Logos */}
        <div className="hidden md:block relative">
          {/* Gradient Fades */}
          <div className="absolute left-0 top-0 bottom-0 w-20 md:w-32 bg-gradient-to-r from-background to-transparent z-10 pointer-events-none" />
          <div className="absolute right-0 top-0 bottom-0 w-20 md:w-32 bg-gradient-to-l from-background to-transparent z-10 pointer-events-none" />

          <div className="flex gap-12 md:gap-16 animate-scroll-left items-center">
            {[...companies, ...companies, ...companies].map((company, index) => (
              <div
                key={`${company.name}-${index}`}
                className="flex-shrink-0 flex items-center gap-3 opacity-60 hover:opacity-100 transition-opacity cursor-default"
              >
                {/* Logo Placeholder */}
                <div className="w-9 md:w-10 h-9 md:h-10 rounded-lg bg-gradient-zavvi flex items-center justify-center">
                  <span className="text-foreground font-bold text-sm md:text-lg">
                    {company.name.split(' ').map(w => w[0]).join('').slice(0, 2)}
                  </span>
                </div>
                <div>
                  <div className="font-display font-semibold text-foreground whitespace-nowrap text-sm md:text-base">
                    {company.name}
                  </div>
                  <div className="text-[10px] md:text-xs text-muted-foreground">{company.sector}</div>
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* Mobile: Grid */}
        <div className="md:hidden grid grid-cols-2 gap-3">
          {companies.slice(0, 6).map((company) => (
            <div
              key={company.name}
              className="glass-card p-3 rounded-xl flex items-center gap-2"
            >
              <div className="w-8 h-8 rounded-lg bg-gradient-zavvi flex items-center justify-center flex-shrink-0">
                <span className="text-foreground font-bold text-xs">
                  {company.name.split(' ').map(w => w[0]).join('').slice(0, 2)}
                </span>
              </div>
              <div className="min-w-0">
                <div className="font-semibold text-foreground text-xs truncate">
                  {company.name}
                </div>
                <div className="text-[10px] text-muted-foreground">{company.sector}</div>
              </div>
            </div>
          ))}
        </div>

        {/* Stats Row */}
        <div className="flex flex-wrap justify-center gap-6 md:gap-16 mt-10 md:mt-12 pt-6 md:pt-8 border-t border-border/30">
          <div className="text-center">
            <div className="text-xl md:text-3xl font-display font-bold text-foreground">500+</div>
            <div className="text-[10px] md:text-xs text-muted-foreground">Empresas Ativas</div>
          </div>
          <div className="text-center">
            <div className="text-xl md:text-3xl font-display font-bold text-cyber-cyan">2M+</div>
            <div className="text-[10px] md:text-xs text-muted-foreground">Mensagens/Mês</div>
          </div>
          <div className="text-center">
            <div className="text-xl md:text-3xl font-display font-bold text-electric-purple">15+</div>
            <div className="text-[10px] md:text-xs text-muted-foreground">Segmentos</div>
          </div>
          <div className="text-center">
            <div className="text-xl md:text-3xl font-display font-bold text-success-green">99.9%</div>
            <div className="text-[10px] md:text-xs text-muted-foreground">Uptime</div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default TrustedBySection;
